import React from 'react';

const CautionIcon = () => {
  return (
    <svg
      className="c-CautionIcon"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        stroke="#666"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        d="M6.86 2.573L1.215 12a1.333 1.333 0 001.14 2h11.293a1.335 1.335 0 001.14-2L9.14 2.573a1.333 1.333 0 00-2.28 0v0zM8 6v2.667M8 11.333h.008"
      ></path>
    </svg>
  );
};

export default CautionIcon;
